import React from 'react';
import PropTypes from 'prop-types';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add';

const style = {
    position: 'fixed',
    right: '24px',
    bottom: '24px',
    zIndex: 1000,
};

const AddEntityActionButton = ({onClick}) => (
    <FloatingActionButton style={style} onClick={onClick} >
        <ContentAddIcon />
    </FloatingActionButton>
);

AddEntityActionButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default AddEntityActionButton;
